import React from "react";
import { Grid, Typography, Container, Button } from "@mui/material";
import InfoImage from "../../assets/Info-13.svg";
import ButtonImg from "../../assets/monitor.png";
import Coin from "../../assets/coin.png";
import Card1Image from "../../assets/Group -166.svg";
import Card1Image2 from "../../assets/Group 163.svg";
import Card1Image3 from "../../assets/Group 159.svg";
import Card1Image4 from "../../assets/Group 165.svg";

import GraphImage from "../../assets/Group 6-1.png";
import "./index.css";
export default function index() {
  return (
    <>
      <Container>
        <Grid container mt={80}>
          <Grid className="blogs-main-text-div">
            <Typography className="main-text-1">
              Take your first step
              <Typography className="main-text-1">
                into<span className="main-text-2"> DeFi</span>
                <span className="main-text-1"> with</span>
                <span className="main-text-2">Terra Treasury</span>
              </Typography>
            </Typography>

            <Grid mt={4} className="main-buttons-div-section-4">
              <Button className="main-button-section">
                <Typography className="main-button-section">
                  Learn More
                </Typography>
                <img src={InfoImage} />
              </Button>
              <Button className="header-button">
                <img src={Coin} />
                <Typography className="header-button-text">Save Now</Typography>
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Grid item lg={6} md={6} sm={12} xs={12} className="blog-1">
          <Grid className="section5-blogs">
            <img src={Card1Image} className="blogs-icons" />
            <Typography className="blogs-text">
              High Yields:
              <span className="blogs-text-2">
                {" "}
                earn the highest stable yield
              </span>
              <Typography className="blogs-text-2">
                in crypto with terra treasury savings.
              </Typography>
            </Typography>
          </Grid>
          <Grid item lg={6} md={6} sm={12} xs={12} className="section5-blogs">
            <img src={Card1Image2} className="blogs-icons" />
            <Typography className="blogs-text">
              Security:
              <span className="blogs-text-2"> Our highest priority is to</span>
              <Typography className="blogs-text-2">
                maximize the safety of our users funds, our
              </Typography>
              <Typography className="blogs-text-2">
                partner projects, and our community.
              </Typography>
            </Typography>
          </Grid>
        </Grid>
        <Grid item lg={6} md={6} sm={12} xs={12} className="blog-1">
          <Grid className="section5-blogs">
            <img src={Card1Image3} className="blogs-icons" />
            <Typography className="blogs-text">
              Flexibility:
              <span className="blogs-text-2"> Deposit and withdraw your</span>
              <Typography className="blogs-text-2">
                savings anytime, anywhere
              </Typography>
              <Typography className="blogs-text-2">
                minimum deposit required for maximum
              </Typography>
              <Typography className="blogs-text-2">flexibility!</Typography>
            </Typography>
          </Grid>
          <Grid item lg={6} md={6} sm={12} xs={12} className="section5-blogs">
            <img src={Card1Image4} className="blogs-icons" />
            <Typography className="blogs-text">
              Stability:
              <span className="blogs-text-2">
                {" "}
                Terra Treasury offers unparalleled
              </span>
              <Typography className="blogs-text-2">
                stable interest rates for UST and LUNA.
              </Typography>
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
